import PriorityHigh from '@mui/icons-material/PriorityHigh';
import { Box } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { UNCONFIRMED_QUALIFICATION_LEVEL_TOOLTIP } from 'domain/shared/candidate';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import type { SourcingCompetencyLevel } from '../../types';
import { INIT_COMPETENCY_LEVEL } from 'domain/shared/newVacancy';

type Props = {
  level: SourcingCompetencyLevel | null;
  isConfirmed: boolean;
};

const LevelsField = ({ level, isConfirmed }: Props) => {
  if (!level) return EMPTY_VALUE_INDICATOR;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {level === INIT_COMPETENCY_LEVEL.N_A ? 'N/A' : level}
      {level !== INIT_COMPETENCY_LEVEL.N_A && !isConfirmed && (
        <Tooltip title={UNCONFIRMED_QUALIFICATION_LEVEL_TOOLTIP}>
          <PriorityHigh color="error" fontSize="small" />
        </Tooltip>
      )}
    </Box>
  );
};

export default LevelsField;
